import { createFileRoute, Outlet } from '@tanstack/react-router'

// Layout route for /outreach. The dashboard lives in outreach.index.tsx and the
// archive in outreach.archive.tsx; this just renders whichever child matches.
export const Route = createFileRoute('/app/startup/$id/outreach')({
  component: Outlet,
})
